import { paymentDetail } from "./paymentReducer";

export const payment_action = (query) => async (dispatch) => {
    try {
        dispatch(paymentDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};